import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../../public/img/left1.png';
import _imports_1 from '../../../../public/img/avatar.png';
import _imports_2 from '../../../../public/kid_a.png';
import _imports_3 from '../../../assets/jqr2.png';
import _imports_4 from '../../../../public/img/close2.png';
import _imports_5 from '../../../assets/laba.png';
import _imports_6 from '../../../assets/click.png';
const _withScopeId = n => (_pushScopeId("data-v-19a17f64"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "position-fiexd position-relative font-bold left-0 top-0 right-0 text-center",
  style: {
    "padding": "15px",
    "color": "#333",
    "background-color": "#f8f8f8",
    "font-size": "16px",
    "width": "100%",
    "z-index": "1"
  }
};
const _hoisted_2 = {
  class: "position-absolute top-0 right-0 bottom-0 flex align-center",
  style: {
    "left": "15px"
  }
};
const _hoisted_3 = {
  class: "box"
};
const _hoisted_4 = {
  key: 0,
  class: "flex"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "teacher-img"
}, null, -1));
const _hoisted_6 = {
  key: 0,
  class: "notice"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "90%",
    "margin-top": "12px"
  },
  class: ""
}, " 我已经为你分析了所有句子，点击确认你要分析的语句 ", -1));
const _hoisted_8 = [_hoisted_7];
const _hoisted_9 = {
  key: 1,
  class: "notice"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "90%",
    "margin-top": "12px"
  },
  class: ""
}, " 小提示：点击具体单词可以查询解释，如果有红色词条，那就是这个词在本句中的唯一解释。 ", -1));
const _hoisted_11 = [_hoisted_10];
const _hoisted_12 = {
  key: 1,
  class: "flex align-center justify-center",
  style: {
    "font-weight": "700",
    "padding-top": "20px"
  }
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {
    "height": "60px",
    "width": "45px",
    "margin-right": "10px"
  }
}, null, -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#333333"
  },
  class: "flex align-center"
}, [/*#__PURE__*/_createElementVNode("span", {
  style: {
    "padding": "5px",
    "background-color": "#f2f2f2"
  }
}, " AI老师分析中... ")], -1));
const _hoisted_15 = [_hoisted_13, _hoisted_14];
const _hoisted_16 = {
  class: "bg-white w-100",
  style: {
    "position": "relative",
    "margin-top": "50px"
  }
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  style: {
    "position": "absolute",
    "top": "-40px",
    "left": "0px"
  }
}, null, -1));
const _hoisted_18 = {
  key: 0,
  id: "section",
  style: {
    "padding": "20px",
    "color": "#032b72",
    "background": "#e7f6ff",
    "border": "1px solid #0086f0",
    "border-radius": "16px"
  }
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = ["innerHTML"];
const _hoisted_21 = ["innerHTML"];
const _hoisted_22 = {
  key: 3,
  style: {
    "padding": "3px",
    "border-width": "0.1px",
    "border-style": "solid",
    "border-radius": "5px",
    "border-color": "#cccccc"
  }
};
const _hoisted_23 = {
  class: "flex"
};
const _hoisted_24 = {
  style: {
    "width": "85%",
    "padding-left": "5px",
    "padding-top": "5px",
    "word-break": "break-all"
  }
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  style: {
    "width": "20px",
    "height": "20px"
  }
}, null, -1));
const _hoisted_26 = [_hoisted_25];
const _hoisted_27 = {
  style: {
    "height": "20px"
  },
  class: "flex align-center"
};
const _hoisted_28 = {
  style: {
    "color": "#485860",
    "margin-left": "5px"
  }
};
const _hoisted_29 = {
  key: 0
};
const _hoisted_30 = {
  key: 0,
  style: {
    "margin-left": "5px",
    "font-size": "12px"
  }
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  style: {
    "margin-left": "5px",
    "width": "15px",
    "height": "15px"
  }
}, null, -1));
const _hoisted_32 = [_hoisted_31];
const _hoisted_33 = {
  style: {
    "margin-top": "5px",
    "margin-bottom": "5px",
    "margin-left": "5px"
  }
};
const _hoisted_34 = {
  style: {
    "text-align": "left",
    "width": "fit-content"
  }
};
const _hoisted_35 = {
  key: 0,
  style: {
    "font-size": "0.6rem",
    "color": "#ffffff",
    "background-color": "#9f35f9"
  }
};
const _hoisted_36 = {
  key: 1,
  style: {
    "font-size": "0.6rem",
    "color": "#ffffff",
    "background-color": "#f2460a"
  }
};
const _hoisted_37 = {
  key: 0,
  style: {
    "font-style": "italic"
  }
};
const _hoisted_38 = {
  style: {
    "margin-left": "5px",
    "margin-right": "5px"
  }
};
const _hoisted_39 = {
  style: {
    "width": "90%",
    "padding-left": "5px",
    "padding-top": "5px"
  }
};
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "原型:", -1));
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_43 = {
  key: 0,
  style: {
    "color": "#485860"
  }
};
const _hoisted_44 = {
  style: {
    "text-align": "left",
    "width": "fit-content"
  }
};
const _hoisted_45 = {
  key: 0,
  style: {
    "font-size": "0.6rem",
    "color": "#ffffff",
    "background-color": "#9f35f9"
  }
};
const _hoisted_46 = {
  key: 1,
  style: {
    "font-size": "0.6rem",
    "color": "#ffffff",
    "background-color": "#f2460a"
  }
};
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-top": "10px"
  }
}, null, -1));
const _hoisted_48 = {
  key: 0,
  class: "position-relative"
};
const _hoisted_49 = ["innerHTML"];
const _hoisted_50 = {
  key: 2
};
const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  style: {
    "display": "block",
    "margin": "10px auto 0"
  }
}, null, -1));
const _hoisted_53 = {
  class: "text-center"
};
const _hoisted_54 = ["src"];
const _hoisted_55 = {
  key: 4
};
const _hoisted_56 = {
  style: {
    "padding": "3px",
    "border-width": "0.1px",
    "border-style": "solid",
    "border-radius": "5px",
    "border-color": "#cccccc"
  }
};
const _hoisted_57 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "chinese",
  style: {
    "color": "#999"
  }
}, "中文释义", -1));
const _hoisted_58 = {
  class: "black",
  style: {
    "margin-top": "10px"
  }
};
const _hoisted_59 = {
  style: {
    "padding": "3px",
    "border-width": "0.1px",
    "border-style": "solid",
    "border-radius": "5px",
    "border-color": "#cccccc",
    "margin-top": "10px"
  }
};
const _hoisted_60 = {
  key: 0
};
const _hoisted_61 = {
  key: 0,
  style: {
    "margin-top": "5px",
    "color": "#2b9af3"
  },
  class: "black"
};
const _hoisted_62 = {
  key: 1,
  style: {
    "margin-top": "20px"
  },
  class: "black"
};
const _hoisted_63 = {
  key: 2,
  style: {
    "margin-top": "20px"
  },
  class: "black"
};
const _hoisted_64 = {
  key: 3,
  style: {
    "margin-top": "20px"
  },
  class: "black"
};
const _hoisted_65 = {
  key: 4,
  style: {
    "margin-top": "20px"
  },
  class: "black"
};
const _hoisted_66 = {
  key: 1
};
const _hoisted_67 = {
  style: {
    "margin-top": "40px"
  },
  class: "black"
};
const _hoisted_68 = {
  style: {
    "margin-top": "20px",
    "color": "#2b9af3"
  },
  class: "black"
};
const _hoisted_69 = {
  key: 0,
  style: {
    "margin-top": "20px"
  },
  class: "black"
};
const _hoisted_70 = {
  key: 1,
  style: {
    "margin-top": "20px"
  },
  class: "black"
};
const _hoisted_71 = {
  key: 2,
  style: {
    "margin-top": "20px"
  },
  class: "black"
};
const _hoisted_72 = {
  key: 3,
  style: {
    "margin-top": "20px"
  },
  class: "black"
};
const _hoisted_73 = {
  key: 2
};
const _hoisted_74 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "black",
  style: {
    "padding": "5px 0",
    "margin-top": "20px",
    "font-weight": "bold"
  }
}, " 选择本句包含的知识点： ", -1));
const _hoisted_75 = ["onClick"];
const _hoisted_76 = {
  style: {
    "font-size": "0.6rem",
    "font-style": "italic",
    "color": "#2e9df6",
    "text-align": "right",
    "width": "fit-content",
    "float": "right"
  }
};
const _hoisted_77 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1));
const _hoisted_78 = {
  style: {
    "color": "#4c99a9",
    "margin-bottom": "5px",
    "font-weight": "bold"
  }
};
const _hoisted_79 = ["innerHTML"];
const _hoisted_80 = {
  style: {
    "color": "#4c99a9",
    "padding-bottom": "5px"
  }
};
const _hoisted_81 = ["innerHTML"];
const _hoisted_82 = {
  style: {
    "padding-bottom": "5px"
  }
};
const _hoisted_83 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  style: {
    "border-width": "0.001rem",
    "border-style": "dashed",
    "margin": "3px"
  }
}, null, -1));
import { onMounted, ref, reactive, computed } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { bizTts, translate, grammarAnalysis } from "../../../api/index";
import { ElMessage } from "element-plus";
export default {
  __name: 'analyse',
  props: {
    bodyStyle: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: ""
    },
    articleId: {
      type: [String, Number],
      default: ""
    },
    readLogId: {
      type: [String, Number],
      default: ""
    }
  },
  emits: ["toView"],
  setup(__props, {
    emit: __emit
  }) {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const emit = __emit;
    const safeMes = computed(() => store.state.safeMes);
    const sentence = computed(() => store.state.sentence);
    const empty_vis = ref(true);
    let linshi = "";
    const nowSentence = ref("");
    const txt = reactive({
      data: []
    });
    const inAnalyse = ref(false);
    const translation = ref("");
    const mSentType = ref("");
    const sub = ref("");
    const pred = ref("");
    const obj = ref("");
    const prej = ref("");
    const isZWB = ref(true);
    const subLRlist = reactive({
      data: []
    });
    let grammer = {};
    const popVis = ref(false);
    const clicked_word = ref("");
    let linshiOffset = "";
    const audioUrl = ref("");
    const phonetic = ref("");
    const translationsV2 = reactive({
      data: []
    });
    const lemma = ref(null);
    const animationList = reactive({
      dataValue: []
    });
    const animationIndex = ref(0);
    const canPlay = ref(false);
    let odl = null;
    const knowledgePoints2 = reactive({
      data: []
    });
    const knowledgeNames2 = reactive({
      data: []
    });
    const knowledgeNamesGrade2 = reactive({
      data: {}
    });
    const activeKnowledgeName2 = ref("");
    const audio = ref(null);
    const props = __props;
    onMounted(() => {
      if (props.type === "component") {
        txt.data = [sentence.value];
        chooseHandler(sentence.value);
      } else {
        if (typeof route.query.txt === "string") {
          txt.data = [route.query.txt] || ["you can"];
        } else {
          txt.data = route.query.txt || ["you can"];
        }
      }
    });
    const toView = () => {
      emit("toView");
    };
    const next = () => {
      if (!canPlay.value) return;
      audio.value[0].play();
      canPlay.value = false;
    };
    const audioEnd = () => {
      animationIndex.value++;
      canPlay.value = true;
    };
    const getSpeaker = () => {
      bizTts(encodeURIComponent(JSON.stringify({
        ...safeMes.value,
        articleId: props.articleId,
        readLogId: props.readLogId,
        content: clicked_word.value
      }))).then(({
        data
      }) => {
        if (data.code) return store.commit("judgeCode", {
          code: data.code,
          msg: data.msg
        });
        audioUrl.value = data.data.audioUrl;
      }).catch(() => {
        ElMessage.error("获取音频失败");
      });
    };
    const toSpeak = () => {
      odl = new Audio();
      odl.src = audioUrl.value;
      odl.play();
    };
    const getTranslate = () => {
      translate(encodeURIComponent(JSON.stringify({
        ...safeMes.value,
        articleId: props.articleId,
        readLogId: props.readLogId,
        content: clicked_word.value,
        sentence: linshi,
        offset: linshiOffset
      }))).then(({
        data
      }) => {
        if (data.code) return store.commit("judgeCode", {
          code: data.code,
          msg: data.msg
        });
        lemma.value = data.data.wordResult.lemma;
        phonetic.value = data.data.wordResult.phonetic;
        translationsV2.data = data.data.wordResult.translationsV2;
        getSpeaker();
      }).catch(() => {
        ElMessage.error("翻译失败");
      });
    };
    const word_popup = e => {
      if (!e.target || e.target.className.indexOf("word") === -1) return;
      const text = e.target.childNodes[0].nodeValue;
      linshiOffset = e.target.attributes["offset0"].nodeValue;
      clicked_word.value = (text || "").trim();
      getTranslate();
      popVis.value = true;
    };
    const back = () => {
      router.go(-1);
    };
    const castSentenceTypeName = sentType => {
      switch (sentType) {
        case "incomplete_sentence":
          return "句式结构不完整";
        case "general_question":
          return "一般疑问句";
        case "special_question":
          return "特殊疑问句";
        case "complete_inversion":
          return "完全倒装句";
        case "partial_inversion":
          return "部分倒装句";
        case "imperative":
          return "祈使句";
        case "declarative":
          return "陈述句";
        default:
          return "";
      }
    };
    const chooseHandler = content => {
      animationIndex.value = 0;
      nowSentence.value = getHtml(content);
      linshi = content;
      console.log("content", content);
      inAnalyse.value = true;
      grammarAnalysis(encodeURIComponent(JSON.stringify({
        ...safeMes.value,
        articleId: props.articleId ? props.articleId - 0 : 0,
        readLogId: props.readLogId ? props.readLogId - 0 : 0,
        content: content
      }))).then(({
        data
      }) => {
        if (data.code) return store.commit("judgeCode", {
          code: data.code,
          msg: data.msg
        });
        empty_vis.value = false;
        inAnalyse.value = false;
        let res = data.data.lineResults[0];
        translation.value = res.translation;
        // 主谓宾
        if (!res.subLRs.length) {
          mSentType.value = res.sentStruct.mSentType;
          sub.value = res.sentStruct.sub.word;
          pred.value = res.sentStruct.pred.word;
          obj.value = res.sentStruct.obj.word;
          prej.value = res.sentStruct.prej.word;
          isZWB.value = res.sentStruct.isZWB;

          // 获取动画
          animationList.dataValue = [...res.animation];
          canPlay.value = true;
          if (props.type === "component") {
            toView();
          }
        } else {
          while (subLRlist.data.length < res.subLRs.length) {
            subLRlist.data.push({});
          }
          for (let i = 0; i < res.subLRs.length; i++) {
            subLRlist.data.splice(i, 1, res.subLRs[i]);
          }
        }
        // 主谓宾
        // 年级
        let index = 0;
        for (let key in res.gradeGrammars) {
          if (!index) res.gradeGrammars[key].active = true;else res.gradeGrammars[key].active = false;
          index++;
          for (var i = 0; i < res.gradeGrammars[key].length; i++) {
            if (!i) res.gradeGrammars[key][i].active = false;else res.gradeGrammars[key][i].active = false;
          }
        }
        grammer = res.gradeGrammars;
        buildKnowledgePoints2();
      }).catch(err => {
        inAnalyse.value = false;
        console.log(err);
        return ElMessage.error("分析失败");
      });
    };
    const chooseAnother = () => {
      empty_vis.value = true;
      inAnalyse.value = false;
    };
    const getHtml = str => {
      return str.replace(/\b(\w+)\b/g, function (m, w, pos) {
        return `<span class="word" offset0="${pos}">${w}</span>`;
      });
    };
    const buildKnowledgePoints2 = () => {
      for (let grade in grammer) {
        let grammarArr = grammer[grade];
        for (let i = 0; i < grammarArr.length; i++) {
          let point = grammarArr[i];
          point.grade = grade;
          knowledgePoints2.data.push(point);
        }
      }
      knowledgePoints2.data.sort(function (a, b) {
        return b["levelId"] - a["levelId"];
      });
      for (let i = 0; i < knowledgePoints2.data.length; i++) {
        let item = knowledgePoints2.data[i];
        if (knowledgeNames2.data.indexOf(item.name) < 0) {
          knowledgeNames2.data.push(item.name);
          knowledgeNamesGrade2.data[item.name] = item.grade;
        }
      }
    };
    const changeKnowledgePointActive2 = knowledgePointName => {
      activeKnowledgeName2.value = knowledgePointName;
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "wrapper",
        style: _normalizeStyle([{
          "width": "100%"
        }, __props.bodyStyle])
      }, [!__props.type ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createTextVNode(" 分析结果 "), _createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
        onClick: _cache[0] || (_cache[0] = $event => back()),
        src: _imports_0,
        style: {
          "width": "10px",
          "height": "15px"
        }
      })])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [!__props.type && !inAnalyse.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_hoisted_5, empty_vis.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8)) : _createCommentVNode("", true), translation.value ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), inAnalyse.value ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_16, [_hoisted_17, empty_vis.value ? (_openBlock(), _createElementBlock("div", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(txt.data, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          onClick: $event => chooseHandler(item),
          key: index
        }, _toDisplayString(item), 9, _hoisted_19);
      }), 128))])) : _createCommentVNode("", true), !empty_vis.value && (animationIndex.value >= animationList.dataValue.length || animationIndex.value == 0) ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        style: {
          "padding": "20px",
          "color": "#032b72",
          "background": "#e7f6ff",
          "border": "1px solid #0086f0",
          "border-radius": "16px"
        },
        onClick: word_popup,
        class: "html-box",
        innerHTML: nowSentence.value
      }, null, 8, _hoisted_20)) : _createCommentVNode("", true), !empty_vis.value && animationIndex.value < animationList.dataValue.length && animationIndex.value >= 1 ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        style: {
          "padding": "20px",
          "color": "#032b72",
          "background": "#e7f6ff",
          "border": "1px solid #0086f0",
          "border-radius": "16px"
        },
        class: "html-box",
        innerHTML: animationList.dataValue[animationIndex.value - 1].markLine
      }, null, 8, _hoisted_21)) : _createCommentVNode("", true), popVis.value ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, _toDisplayString(clicked_word.value), 1), _createElementVNode("div", {
        style: {
          "z-index": "15",
          "width": "15%",
          "font-size": "24px",
          "font-weight": "700",
          "color": "white",
          "text-align": "center",
          "padding-right": "10px"
        },
        onClick: _cache[1] || (_cache[1] = $event => popVis.value = false)
      }, _hoisted_26)]), _createElementVNode("div", _hoisted_27, [_createElementVNode("span", _hoisted_28, [_createTextVNode(" ["), phonetic.value ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(phonetic.value), 1)) : _createCommentVNode("", true), _createTextVNode("] ")]), !audioUrl.value ? (_openBlock(), _createElementBlock("span", _hoisted_30, " 音频加载中... ")) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        onClick: toSpeak,
        style: {
          "width": "40px",
          "height": "20px",
          "display": "flex",
          "align-items": "center"
        }
      }, _hoisted_32))]), _createElementVNode("div", _hoisted_33, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(translationsV2.data, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          style: {
            "color": "#032b72",
            "border-bottom-color": "#dddddd",
            "border-bottom-style": "dashed",
            "border-bottom-width": "0.05rem",
            "padding": "1px"
          }
        }, [_createElementVNode("div", _hoisted_34, [item.isVariant ? (_openBlock(), _createElementBlock("span", _hoisted_35, "↓词性要点")) : item.bestIndexes.length > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_36, "↓最佳解释")) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_createElementVNode("span", {
          style: _normalizeStyle(item.bestIndexes.length > 0 ? 'color: #f2460a;' : '')
        }, _toDisplayString(item.pos), 5), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.explains, (explain, idxL2) => {
          return _openBlock(), _createElementBlock("span", {
            key: idxL2
          }, [idxL2 > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createTextVNode(",")], 64)) : _createCommentVNode("", true), _createElementVNode("span", {
            style: _normalizeStyle(item.isVariant ? 'color:#9f35f9;' : item.bestIndexes.indexOf(idxL2) != -1 ? 'color: #f2460a;' : '')
          }, _toDisplayString(explain), 5)]);
        }), 128))])]);
      }), 128))]), lemma.value ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_hoisted_40, _hoisted_41, _createElementVNode("span", null, _toDisplayString(lemma.value.word), 1), _hoisted_42, lemma.value.phonetic ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString("[ " + lemma.value.phonetic + " ]"), 1)) : _createCommentVNode("", true)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lemma.value.translationsV2, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          style: {
            "color": "#032b72",
            "border-bottom-color": "#dddddd",
            "border-bottom-style": "dashed",
            "border-bottom-width": "0.05rem",
            "padding": "1px"
          }
        }, [_createElementVNode("div", _hoisted_44, [item.isVariant ? (_openBlock(), _createElementBlock("span", _hoisted_45, "↓词性要点")) : item.bestIndexes.length > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_46, "↓最佳解释")) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_createElementVNode("span", {
          style: _normalizeStyle(item.bestIndexes.length > 0 ? 'color: #f2460a;' : '')
        }, _toDisplayString(item.pos), 5), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.explains, (explain, idxL2) => {
          return _openBlock(), _createElementBlock("span", {
            key: idxL2
          }, [idxL2 > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createTextVNode(",")], 64)) : _createCommentVNode("", true), _createElementVNode("span", {
            style: _normalizeStyle(item.isVariant ? 'color:#9f35f9;' : item.bestIndexes.indexOf(idxL2) != -1 ? 'color: #f2460a;' : '')
          }, _toDisplayString(explain), 5)]);
        }), 128))])]);
      }), 128))])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _hoisted_47, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(animationList.dataValue, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index
        }, [index == animationIndex.value ? (_openBlock(), _createElementBlock("div", _hoisted_48, [!(canPlay.value && !animationIndex.value) ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "html-box",
          style: {
            "margin": "5px",
            "padding": "0 5px 5px 5px",
            "width": "100%"
          },
          innerHTML: item.text
        }, null, 8, _hoisted_49)) : _createCommentVNode("", true), animationIndex.value < animationList.dataValue.length && animationIndex.value >= 1 && canPlay.value ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          onClick: next,
          class: "button flex align-center justify-center"
        }, " 点击查看下一步 ")) : _createCommentVNode("", true), !animationIndex.value && animationList.dataValue.length && canPlay.value ? (_openBlock(), _createElementBlock("div", _hoisted_50, [_createElementVNode("div", {
          onClick: next,
          style: {
            "color": "#032b72",
            "text-align": "center"
          }
        }, [_createTextVNode(" AI分析完毕"), _hoisted_51, _createTextVNode("点击查看结果(有声音哦) "), _hoisted_52])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_53, [_createElementVNode("audio", {
          onEnded: audioEnd,
          src: item.audio,
          ref_for: true,
          ref_key: "audio",
          ref: audio
        }, null, 40, _hoisted_54)])])) : _createCommentVNode("", true)]);
      }), 128)), !empty_vis.value && animationIndex.value >= animationList.dataValue.length ? (_openBlock(), _createElementBlock("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, [_hoisted_57, _createElementVNode("div", _hoisted_58, _toDisplayString(translation.value), 1)]), _createElementVNode("div", _hoisted_59, [!subLRlist.data.length ? (_openBlock(), _createElementBlock("div", _hoisted_60, [mSentType.value ? (_openBlock(), _createElementBlock("div", _hoisted_61, " 本句为: " + _toDisplayString(castSentenceTypeName(mSentType.value)), 1)) : _createCommentVNode("", true), sub.value ? (_openBlock(), _createElementBlock("div", _hoisted_62, " 主语: " + _toDisplayString(sub.value), 1)) : _createCommentVNode("", true), pred.value ? (_openBlock(), _createElementBlock("div", _hoisted_63, [isZWB.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode("谓语: ")], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createTextVNode("系动词: ")], 64)), _createTextVNode(" " + _toDisplayString(pred.value), 1)])) : _createCommentVNode("", true), obj.value ? (_openBlock(), _createElementBlock("div", _hoisted_64, " 宾语: " + _toDisplayString(obj.value), 1)) : _createCommentVNode("", true), prej.value ? (_openBlock(), _createElementBlock("div", _hoisted_65, " 表语: " + _toDisplayString(prej.value), 1)) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_66, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subLRlist.data, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index
        }, [_createElementVNode("div", _hoisted_67, " 并列句" + _toDisplayString(index + 1) + ": " + _toDisplayString(item.origLine), 1), _createElementVNode("div", _hoisted_68, " 本句为: " + _toDisplayString(castSentenceTypeName(item.sentStruct.mSentType)), 1), item.sentStruct.sub.word ? (_openBlock(), _createElementBlock("div", _hoisted_69, " 主语: " + _toDisplayString(item.sentStruct.sub.word), 1)) : _createCommentVNode("", true), item.sentStruct.pred.word ? (_openBlock(), _createElementBlock("div", _hoisted_70, [item.sentStruct.isZWB ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createTextVNode("谓语: ")], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createTextVNode("系动词: ")], 64)), _createTextVNode(" " + _toDisplayString(item.sentStruct.pred.word), 1)])) : _createCommentVNode("", true), item.sentStruct.obj.word ? (_openBlock(), _createElementBlock("div", _hoisted_71, " 宾语: " + _toDisplayString(item.sentStruct.obj.word), 1)) : _createCommentVNode("", true), item.sentStruct.prej.word ? (_openBlock(), _createElementBlock("div", _hoisted_72, " 表语: " + _toDisplayString(item.sentStruct.prej.word), 1)) : _createCommentVNode("", true)]);
      }), 128))]))]), _createElementVNode("div", {
        class: "flex align-center",
        style: {
          "justify-content": "space-between",
          "margin-top": "40px"
        }
      }, [_createElementVNode("div", {
        style: {
          "width": "45%"
        },
        class: "button flex align-center justify-center",
        onClick: chooseAnother
      }, " 返回换一句 "), _createElementVNode("div", {
        style: {
          "width": "45%",
          "background": "#e7f6ff",
          "color": "#2b9af3",
          "border": "1px solid #2b9af3"
        },
        class: "button flex align-center justify-center",
        onClick: back
      }, " 返回首页 ")])])) : _createCommentVNode("", true)]), !empty_vis.value && animationIndex.value >= animationList.dataValue.length ? (_openBlock(), _createElementBlock("div", _hoisted_73, [_hoisted_74, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(knowledgeNames2.data, (name, idx) => {
        return _openBlock(), _createElementBlock("div", {
          key: 'point-name-' + idx,
          style: {
            "margin": "5px"
          },
          class: _normalizeClass(["inline-block", activeKnowledgeName2.value == name ? 'active' : 'bg-dec']),
          onClick: $event => changeKnowledgePointActive2(name)
        }, [_createElementVNode("div", null, _toDisplayString(name), 1), _createElementVNode("div", _hoisted_76, _toDisplayString(knowledgeNamesGrade2.data[name]), 1)], 10, _hoisted_75);
      }), 128)), _hoisted_77, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(knowledgePoints2.data, (item, idx) => {
        return _openBlock(), _createElementBlock(_Fragment, null, [item.name == activeKnowledgeName2.value ? (_openBlock(), _createElementBlock("div", {
          key: 'point-value-' + idx,
          style: {
            "padding": "5px"
          }
        }, [_createElementVNode("div", _hoisted_78, _toDisplayString(item.name), 1), _createElementVNode("div", {
          style: {
            "margin-bottom": "5px"
          },
          class: "html-box",
          innerHTML: item.markLine
        }, null, 8, _hoisted_79), _createElementVNode("div", _hoisted_80, [_createElementVNode("span", {
          class: "html-box",
          innerHTML: item.description
        }, null, 8, _hoisted_81)]), _createElementVNode("div", _hoisted_82, _toDisplayString(item.sample), 1), _hoisted_83])) : _createCommentVNode("", true)], 64);
      }), 256))])) : _createCommentVNode("", true)])], 4);
    };
  }
};